import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FileText, Github, Moon, Sun } from 'lucide-react';
import { Button } from '../ui/Button';

export const Header = () => {
  const location = useLocation();
  const isEditor = location.pathname === '/editor';
  const [isDark, setIsDark] = useState(false);

  useEffect(() => {
    if (isDark) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }, [isDark]);

  return (
    <header className="sticky top-0 z-50 w-full border-b border-gray-200 dark:border-gray-800 bg-white/80 dark:bg-gray-900/80 backdrop-blur-sm transition-colors">
      <div className="container mx-auto px-4 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center space-x-2">
          <div className="w-8 h-8 bg-blue-600 rounded-lg flex items-center justify-center text-white">
            <FileText size={20} />
          </div>
          <span className="font-bold text-xl text-gray-900 dark:text-white">CareerCanvas</span>
        </Link>

        {!isEditor && (
          <nav className="hidden md:flex items-center space-x-6">
            <Link to="/templates" className="text-gray-600 hover:text-blue-600 dark:text-gray-300 dark:hover:text-blue-400 font-medium text-sm transition-colors">
              Templates
            </Link>
          </nav>
        )}

        <div className="flex items-center space-x-4">
          <button 
            onClick={() => setIsDark(!isDark)}
            className="p-2 text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200 transition-colors"
          >
            {isDark ? <Sun size={20} /> : <Moon size={20} />}
          </button>
          
          <a href="https://github.com" target="_blank" rel="noreferrer" className="text-gray-500 hover:text-gray-900 dark:text-gray-400 dark:hover:text-white transition-colors">
            <Github size={20} />
          </a>
          {!isEditor && (
            <Link to="/templates">
              <Button size="sm">Create Resume</Button>
            </Link>
          )}
        </div>
      </div>
    </header>
  );
};
